module.exports = __webpack_public_path__ + "img/teams-fr-ca.2701e287.jpg";